import { Typography } from "@mui/joy";
import React from "react";
import { useSiteContext } from "../../../context/siteContext";
import S3DocumentsUpload from "../../../components/S3DocumentsUpload";
import { RouteComponentProps } from "../../../models/RouteComponent";

export default function SiteDocuments(props: RouteComponentProps) {
  const { site } = useSiteContext();
  const { session } = props;
  const site_id = session?.site_id;
  const client_id = session?.client_id;
  return (
    <>
      <Typography level="h2" component="h1">
        Site Documents: {site?.name}
      </Typography>
      <S3DocumentsUpload
        setGlobalLoader={props.setGlobalLoader}
        record_id={site_id || ""}
        client_id={client_id}
        type="site"
        props={props}
      />
    </>
  );
}
